import React from 'react';
import { connect } from 'react-redux';

import DangerZoneCard from './DangerZoneCard';

import { selectSuccess } from '../../../../redux/auth/deleteAccount/selectors';
import { selectIsUserPaying } from '../../../../redux/auth/user/selectors';

const DangerZoneCardConnected = (props) => <DangerZoneCard {...props} />;

const mapStateToProps = (state) => ({
  deleteAccountSuccess: selectSuccess(state),

  isUserPaying: selectIsUserPaying(state),
});

export default connect(mapStateToProps)(DangerZoneCardConnected);
